/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CRSFSecReviewPrivacySpecificTrackingTechEnum = {
    GoogleAnalytics: 'Google Analytics',
    GoogleAdsAdWords: 'Google Ads (AdWords)',
    Facebook: 'Facebook',
    DataDog: 'DataDog',
    Hotjar: 'Hotjar',
    Pendo: 'Pendo',
    ContentSquare: 'ContentSquare'
} as const;
export type CRSFSecReviewPrivacySpecificTrackingTechEnum = typeof CRSFSecReviewPrivacySpecificTrackingTechEnum[keyof typeof CRSFSecReviewPrivacySpecificTrackingTechEnum];


export function CRSFSecReviewPrivacySpecificTrackingTechEnumFromJSON(json: any): CRSFSecReviewPrivacySpecificTrackingTechEnum {
    return CRSFSecReviewPrivacySpecificTrackingTechEnumFromJSONTyped(json, false);
}

export function CRSFSecReviewPrivacySpecificTrackingTechEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewPrivacySpecificTrackingTechEnum {
    return json as CRSFSecReviewPrivacySpecificTrackingTechEnum;
}

export function CRSFSecReviewPrivacySpecificTrackingTechEnumToJSON(value?: CRSFSecReviewPrivacySpecificTrackingTechEnum | null): any {
    return value as any;
}

